// extracted by mini-css-extract-plugin
module.exports = {"dp-RichText":"dp-RichText___1le8J","media-wrap":"media-wrap___1-XJq","image-wrap":"image-wrap___zt_Yw","float-right":"float-right___1LK7v","float-left":"float-left___h5GJy"};